//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      show: false
    }
  },
  methods: {
    toView(url) {
      window.location.href = url
    }
  },
  watch: {
    '$route': function(n) {
      if(n.name == 'result' && n.query && n.query.type == 'appointment') this.show = false
      else this.show = n.meta && n.meta.searchOrder
    },
  }
}
